export const isWorkspaceEmbedded = () =>
  new URLSearchParams(window.location.search).get("workspace") === "embedded" &&
  window.parent !== window;

/** Only frames with an upgrade bridge may hand off their modal to the host. */
export const isWorkspaceVipUpgradeHosted = () =>
  isWorkspaceEmbedded() &&
  new URLSearchParams(window.location.search).get("workspaceUpgrade") === "host";

export const WORKSPACE_EMBEDDED_MESSAGE_SOURCE = "chatyy:workspace-embedded";

export const notifyWorkspaceLoginCancelled = () => {
  if (!isWorkspaceEmbedded()) return false;

  window.parent.postMessage(
    {
      source: WORKSPACE_EMBEDDED_MESSAGE_SOURCE,
      type: "chatyy:workspace:login-cancelled",
    },
    window.location.origin,
  );
  return true;
};

/**
 * 嵌入 V2 工作区的旧页面不能直接在 iframe 内跳转，否则会产生 V2 嵌套。
 * 返回 true 表示导航已交给外层工作区处理。
 */
export const requestWorkspaceNavigation = (
  pathname: string,
  search = "",
) => {
  if (!isWorkspaceEmbedded()) return false;

  window.parent.postMessage(
    {
      source: WORKSPACE_EMBEDDED_MESSAGE_SOURCE,
      type: "chatyy:workspace:navigate",
      pathname,
      search,
    },
    window.location.origin,
  );
  return true;
};

/**
 * 嵌入工作区时，由外层页面统一展示加油包弹窗。
 * iframe 自己展示弹窗会受 iframe 尺寸和层级限制，并可能与外层弹窗重复。
 */
export const requestWorkspaceRefuelBag = (entrance: string) => {
  if (!isWorkspaceEmbedded()) return false;

  window.parent.postMessage(
    {
      source: WORKSPACE_EMBEDDED_MESSAGE_SOURCE,
      type: "chatyy:workspace:open-refuel",
      entrance,
    },
    window.location.origin,
  );
  return true;
};

/** 开通记录与后续发票操作在工作区外层展示，避免 iframe 裁切。 */
export const requestWorkspacePayHistory = () => {
  if (!isWorkspaceEmbedded()) return false;
  window.parent.postMessage({
    source: WORKSPACE_EMBEDDED_MESSAGE_SOURCE,
    type: 'chatyy:workspace:open-pay-history',
  }, window.location.origin);
  return true;
};

/** 发票抽屉由工作区外层展示，避免遮罩和抽屉被 iframe 边界裁切。 */
export const requestWorkspaceInvoice = (options: {
  orderNo?: string;
  applicationId?: string;
} = {}) => {
  if (!isWorkspaceEmbedded()) return false;
  window.parent.postMessage({
    source: WORKSPACE_EMBEDDED_MESSAGE_SOURCE,
    type: 'chatyy:workspace:open-invoice',
    orderNo: options.orderNo,
    applicationId: options.applicationId,
  }, window.location.origin);
  return true;
};

/** 支付成功弹窗由工作区外层展示，避免全屏遮罩仅覆盖 iframe。 */
export const requestWorkspacePaySuccess = (message?: string) => {
  if (!isWorkspaceEmbedded()) return false;
  window.parent.postMessage({
    source: WORKSPACE_EMBEDDED_MESSAGE_SOURCE,
    type: 'chatyy:workspace:pay-success',
    message,
  }, window.location.origin);
  return true;
};
